<template>
  <div id="AdvancedOptions" ref="container">
    <div class="content_area">
      <div class="form_wrap">
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">绘画描述</div>
          </div>
          <div class="btm_area_con">
            <!--                        <div class="input_wrap" flex-align>-->
            <!--                            <input class="input_main" v-model="inputVal"-->
            <!--                                placeholder="请输入绘画描述" />-->
            <!--                        </div>-->
            <div>
                <textarea class="text" rows="4" v-model="inputVal"
                          placeholder="输入绘画描述词，描述词越详细生成的图片效果更佳~"></textarea>
            </div>
            <div class="depict_switch">
              <div class="switch">
                <el-switch
                    style="zoom: 0.7"
                    @change="getPromptData4()"
                    active-value="1"
                    inactive-value="0"
                    active-color="#5865f2"
                    inactive-color="#53555f"
                    v-model="auto_spell">
                </el-switch>
                <span>一键优化描述词</span>
              </div>
              <div class="empty" @click="inputVal=''">清空</div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">模型选择</div>
          </div>
          <div class="model_list">
            <!--                  <div @click="img_model=mo.name" :class="['model_item', { 'active': mo.name == img_model }]" v-for="mo in model_list">-->
            <!--                    <div class="model_title" flex-center>{{ mo.title }}</div>-->
            <!--                  </div>-->
            <div class="quality">
              <div @click="img_model = mo.name" v-for="(mo) in model_list"
                   :class="mo.name===img_model?'quality_btns':'quality_btn'">
                {{ mo.name === 'NJ6.0' ? '动漫模型' : '真实模型' }}
              </div>
            </div>
          </div>
        </div>
        <div class="options_item">
          <div class="item_title" flex-align>
            <div class="text">图片质量</div>
          </div>
          <div class="image_quality">
            <div class="item_con">
              <div class="quality">
                <div @click="form.quality=item.num" v-for="(item) in qualityImg"
                     :class="item.num===form.quality?'quality_btns':'quality_btn'">
                  {{ item.name }}
                </div>
              </div>
              <div class="brief">
                {{ form.quality === 0 ? '标准' : '高清' }}绘图质量，需消耗{{ form.quality === 0 ? '2' : '4' }}积分
              </div>
            </div>

          </div>
        </div>
        <div class="options_item">
          <div class="item_title flex jb ac ">
            <div class="text">
              生成尺寸--ar
              <span class="fz12" style="margin-left: 10px;color: #6D6D6D;">选择生成图像的宽度×高度比例</span>
            </div>
          </div>
          <div class="item_con">
            <div class="size_list flex">
              <div class="size_item flex fc jc ac" :class="form.aspect == item.size ? 'active' : ''"
                   @click="choose_aspect(item)" v-for="(item, index) in img_size" :key="index">
                <img :src="require('../img/s' + (index + 1) + '.png')"/>
                <p>{{ item.size }}</p>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="bottom_area" flex-center>
      <div class="primary_button" @click="sendMsg" v-loading="sending">提交任务</div>
    </div>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
  </div>
</template>

<script>
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import utils from '@/utils/index.js'
export default {
  components: {faceVerifyPopup},
  props: ['sampleList'],
  data() {
    return {
      //展示隐藏search_tips
      inputVal: "",
      sending: false,
      search_tips: false,
      //模型列表
      model_list: [{
        img_url: "/static/img/mode/nj6.0.png",
        name: "NJ6.0",
        title: 'NJ6.0(动漫质感)',
        desc: '官方最新动漫模型同步',
      }, {
        img_url: "/static/img/mode/mj6.0.png",
        name: "MJ6.0",
        title: 'MJ6.0(真实质感)',
        desc: '全新6.0 ALPHA真实风格图像',
      }],
      is_fast: 1,
      //当前选中模型
      img_model: 'NJ6.0',
      fileList: [],
      iw_options: [
        {
          label: '关闭iw选项',
          value: '0'
        },
        {
          label: '--iw 0.25 相似度30%',
          value: '0.25'
        },
        {
          label: '--iw 0.5 相似度40%',
          value: '0.5'
        },
        {
          label: '--iw 1 相似度50%',
          value: '1'
        },
        {
          label: '--iw 1.25 相似度60%',
          value: '1.25'
        },
        {
          label: '--iw 1.5 相似度70%',
          value: '1.5'
        },
        {
          label: '--iw 1.75 相似度80%',
          value: '1.75'
        },
        {
          label: '--iw 2 相似度90%',
          value: '2'
        },
      ],
      img_size: [
        {
          size: '1:1',
          title: '头像框'
        },
        {
          size: '1:2',
          title: '手机壁纸'
        },
        {
          size: '16:9',
          title: '电脑壁纸'
        },
        {
          size: '9:16',
          title: '宣传海报'
        },
        {
          size: '4:3',
          title: '文章配图'
        },
        {
          size: '3:4',
          title: '媒体配图'
        },
        {
          size: '3:2',
          title: '横版名片'
        },
        {
          size: '2:3',
          title: '小红书图'
        },
      ],
      qualityImg: [
        {
          name: '标准',
          num: 0,
        },
        {
          name: '高清',
          num: 100,
        },
      ],
      iw: "0.25",
      upload_img_url: "",
      form: {
        iw: "0.25",
        aspect: "1:1",// 大小比例
        is_public: '0',//是否公开作品
        quality: 0,
        stylize: 100,
        chaos: 0,
        upload_list: []
      },
      fileApi: FILE_API_SERVER,
      upoadLoading: false,
      uploadError: '',
      okNum: 0,
      totalNum: 0,
      isWxEnv: false,

      perIncan: false, // ai提示词是否返回
      auto_spell: '1', // ai提示词是否关闭
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    tips_list() {
      return this.sampleList.slice(this.sampleList.length - 20, this.sampleList.length)
    },
    isInputtype() {
      return this.$store.state.isInputtype;
    },
    isInputVal() {
      return this.$store.state.isInputVal;
    },
  },
  created() {
    var ua = navigator.userAgent.toLowerCase();
    if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
      this.isWxEnv = true
    } else {
      this.isWxEnv = false
    }
    this.initData()
  },
  mounted() {
    setTimeout(() => {
      document.addEventListener('click', this.handleDocumentClick);
      let _form = this.getCache("formAdvanceParams") || ""
      if (_form) {
        this.form = JSON.parse(_form)
      }
    }, 100)
  },
  methods: {
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },

    //选择提示词
    choose_tips_item(item) {
      let _item = {...item}
      _item.progress = 0
      this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")
      this.sampleUserList = [_item].concat(this.sampleUserList);
      localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))

      this.$emit('select_sample', _item);
    },

    initData() {
      this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
    },
    choose_aspect(item) {
      this.form.aspect = item.size
    },
    handleDocumentClick(event) {
      // 判断点击的区域是否是 container 元素或其子元素
      if (this.$refs.container && !this.$refs.container.contains(event.target)) {
        // 点击了除 container 以外的区域，执行相应操作
        this.setCache("formAdvanceParams", JSON.stringify(this.form), 60 * 60 * 1000)
      }
    },
    handleSuccess(response, file, fileList) {
      console.log("handleSuccess", response, file)
    },

    //发送消息
    sendMsg() {

      if (!this.checkLogin()) return
      if(!utils.setOptData(this.userInfo,'btn_dalle3_create')){
          return
      }
      this.inputVal = this.inputVal.trim();
      if (!this.inputVal) {
        this.$message.warning('请输入文字信息')
        return
      }

      if (this.sending) {
        this.$message.warning('请等待上次绘图完成')
        return
      }
      if (this.auto_spell > 0) {
        console.log('ai提示词')
        if (!this.perIncan) {
          this.$store.commit('setisInputVal', this.inputVal)
          this.$store.commit('setisInputtype', 'Stable Diffusion')
          this.$store.commit('setisInputValshow', true)
          return;
        }
      }
      let parameters = {
        iw: 0.25,
        aspect: "16:9",// 大小比例
        // tips_text:"",
        quality: 0,
        stylize: 100,
        chaos: 100,
        upload_list: []
      }
      parameters = this.form
      // 同步请求
      this.submitQuestion({
        question: this.inputVal,
        parameters: parameters,
        img_model: this.img_model,
        is_fast: this.is_fast,
        iw_url: this.upload_img_url,
        iw: this.img_iw
      });

    },
    submitQuestion(data, parent_msg_code, i) {
      console.log('提交1')
      console.log(data)
      // 提交问题
      this.sending = true;
      data.source = "pc";
      this.perIncan = false
      this.$http.post('/front/aidl/draw/', data).then((res) => {
        if (res.status == 200) {
          this.inputVal = "";
          // this.checkIds.push(res.data.draw.draw_id)
          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });
          // this.fetchMsg();
          this.$emit('submitForm', {})
        } else {
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              console.log('进入会员中心')
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    getPromptData4() {
      // 关闭
      console.log('auto_spell', this.auto_spell)
      if (this.auto_spell == 0) {
        this.$confirm('关闭自动优化描述词，生成的绘画内容可能不佳，请谨慎关闭!', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.auto_spell = '0'
        }).catch(() => {
          this.auto_spell = '1'
        });
      }
    },
  },
  watch: {
    '$store.state.isInputValshow'(newVal) {
      console.log('isInputValshow 变化1:', newVal);
      if (!newVal) {
        if (this.isInputtype.length > 0) {
          this.perIncan = true
          this.inputVal = this.isInputVal
          this.sendMsg()
        }
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.fg1 {
  flex: 1;
}

#AdvancedOptions {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: hidden;
  color: #fff;
  background-color: #2b2d31;

  .content_area {
    overflow: hidden;
    flex: 1 1 0%;

    .form_wrap {
      overflow-y: auto;
      padding: 5px 15px 15px;
      height: 100%;
    }

    .options_item {
      margin: 10px 0 10px;

      .item_title {
        margin-bottom: 10px;

        .text {
          position: relative;
          padding-left: 10px;
          white-space: normal;

          &:before {
            content: "";
            width: 4px;
            height: 15px;
            background: #5865f2;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 4px;
          }

          .icon {
            font-size: 15px;
            margin: 0 0 -2px 10px;
            color: #4a4c52;
            font-weight: bold;
          }
        }
      }

      .item_con {
        .el-switch {
          margin-left: 10px;
        }
      }
    }
  }

  .bottom_area {
    padding-top: 10px;
    background-color: #2b2d31;
    height: 90px;
    width: 100%;
    padding: 0 30px;

    .primary_button {
      font-size: 16px;
      height: 46px;
      padding-top: 13px;
      padding-bottom: 13px;
      border-radius: 9999px;
      flex: 1 1 0%;
    }
  }
}

.btm_area_con {
  //position: relative;
  border-radius: 5px;
  border: 2px solid #5865f2;
  padding: 10px 10px;

  .text {
    width: 100%;
    background-color: #2b2d31;
    border: 0;
    color: #b4b9bf;
    font-size: 14px;
    letter-spacing: 1.5px;
    line-height: 20px;
  }

  .depict_switch {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin-top: 10px;
    line-height: 1;

    .switch {
      display: flex;
      align-items: center;

      span {
        margin-left: 10px;
      }
    }

    .empty {
      color: #b4b9bf;
      cursor: pointer;
    }

    .empty:hover {
      color: #fff;
    }
  }
}

.image_quality {
  //display: grid;
  //grid-template-columns: 1fr 1fr 1fr;
  //gap: 10px;
  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 50px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 50px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

  }

  .brief {
    color: #7E7E7E;
    font-size: 14px;
    margin: 8px 0;
  }
}

.model_list {
  display: flex;


  .model_item {
    border-radius: 6px;
    border: 2px solid #1d2027;
    position: relative;
    overflow: hidden;

    &.active {
      border-color: #5865f2;
    }

    img {
      border: none;
      width: 100%;
    }

    .model_title {
      position: absolute;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.73);
      height: 25px;
      font-size: 12px;
      left: 0;
      bottom: 0;
    }
  }

  .quality {
    display: flex;
    color: #fff;
    font-size: 14px;

    .quality_btn {
      border: 2px solid #393c43;
      border-radius: 3px;
      background-color: #1d2027;
      padding: 10px 35px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

    .quality_btns {
      border: 2px solid #5865f2;
      border-radius: 3px;
      background-color: #303245;
      padding: 10px 35px;
      margin: 0 20px 0 0;
      cursor: pointer;
    }

  }

}


.size_list {
  padding-top: 14px;
  flex-wrap: wrap;

  .size_item {
    border: 2px solid #393c43;
    width: 70px;
    height: 100px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 4px;
    cursor: pointer;

    img {
      width: 36px;
      height: 40px;
    }

    p {
      font-size: 12px;
      color: #8e9093;
      margin-top: 6px;
    }

    &.active {
      border: 2px solid #5865f2;
    }
  }
}


.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1501;
  bottom: 0;
  left: 0;
  transition: all 0.3s;
  background: rgba(0, 0, 0, 0.8);
  overflow: auto;
  animation: fadeInSlowAni 0.3s 1;

  .centerPanel {
    position: fixed;
    z-index: 1501;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: transform 0.2s;
  }
}

/deep/ .el-loading-mask {
  background: none;
}
</style>